import { combineReducers } from 'redux';
import { consoleLogReducer, runSequenceReducer } from './3ds-reducers';

const reducers = combineReducers({
  runSeqReducer: runSequenceReducer,
  logReducer: consoleLogReducer
});

export default reducers;
